import pageCache from 'api/page-cache';
// import isEmpty from 'lodash/isEmpty';
import each from 'lodash/each';
import DataProvider from 'api/data-provider';
import seoPreload from 'api/seo';
import { blockPreloader } from 'containers/content-block';
import { aggInfoUrls } from 'src-sites/backoffice/section-admin/seo/landings/editor/aggConfig';
import { simpleCheck } from '../api/data-check';

/**
 * Generate standart preloader for location-based landing pages
 *
 * @param routeProps
 * @param blockConfig
 * @return Preloader configuration
 *
 * Available options:
 *    cacheId - Unique ID for client preloader cache
 *    dataLimit - limit for data provider
 *    dataQuery - advanced query params
 *    queryBuilder - advanced query builder. Overrides dataQuery and landing query params
 *    isSearchQuery - callback, that returns true, if search query is present
 *    noPreloadQuery - do not run data preloader for landing data. Needed for "map only" pages
 *
 */
export default function landingPreloader(routeProps, blockConfig, options) {
  const { params: { landing, page } } = routeProps;
  const aggInfo = {};
  const dataQuery = options.dataQuery || {};
  each(landing.aggregations, (val, key) => {
    const infoUrl = aggInfoUrls[landing.aggregator.config][key];
    if (!infoUrl) return;
    aggInfo[key] = [DataProvider.preload, {
      url: infoUrl.url,
      cache: 60 * 24,
      query: { id: val, ...infoUrl.query },
      requestClientCache: key,
    }];
  });

  const { location = {} } = routeProps;
  const isQuery = options.isSearchQuery ? options.isSearchQuery() : false;
  const buildedQuery = options.queryBuilder ?
    options.queryBuilder(routeProps.params, location) : {};

  const checkIsExistsData = isQuery ? {} : simpleCheck(['listData']);
  const isQueryParams = isQuery ? (options.isQueryParams || {}) : {};
  const landingParams = isQuery ? {} : landing.params;

  /*
  console.log({
    count: true,
    limit: options.dataLimit,
    page,
    ...landingParams,
    ...dataQuery,
    ...buildedQuery,
    ...isQueryParams, // Todo to discuss (filter ready_status)
  });
  */


  const dataPreloader = options.noPreloadQuery ? {} : {
    listData: [DataProvider.preload, {
      url: landing.provider,
      queryJson: true,
      cache: isQuery ? null : 240,
      requestClientCache: isQuery ? null : 1,
      query: {
        count: true,
        limit: options.dataLimit,
        page,
        ...landingParams,
        ...dataQuery,
        ...buildedQuery,
        ...isQueryParams, // Todo to discuss (filter ready_status)
      }
    }],
    ...pageCache('listData'),
    ...checkIsExistsData
  };

  return {
    landing: [() => Promise.resolve({
      ...landing,
      query: landing.params,
      breadcrumbsPath: landing.breadcrumbs_path,
    }), {}],
    ...aggInfo,
    ...dataPreloader,
    ...seoPreload({ group_id: landing.group_id }, ['landing', ...Object.keys(aggInfo)]),
    ...blockPreloader({
      project: __CLIENT__ ? window.__PROJECT__ : global.__PROJECT__,
      group_id: landing.group_id
    }, blockConfig, ['landing', ...Object.keys(aggInfo)])
  };
}
